import i18next from 'i18next';

export const PRODUCT = {
  getText: () => i18next.t('FEATURE.ADMIN.PRODUCTS'),
  path: '/admin/products/:id/details',
  getLink: ({ productId }) => `/admin/products/${productId}/details`,
  isVisible: () => false,
};
